import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { ConcentracionService } from '../../../services/riesgo-liquidez/concentracion.service';
import { MatMenuTrigger } from '@angular/material/menu';
import Swal from 'sweetalert2';
import { calculos, CommonVariables, FuncionesMes, obtenerError } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { concentracion, perspectivas } from '../tablaslds';
import { IMG } from '../../../services/imagen/png';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { messages } from '../../funciones/mensajes';

interface HistoricalDataItem {
  name: string;
  saldos: any[];
  cuentas: any[];
}

interface HistoricalPeriodItem {
  periodos: any[];
}
@Component({
  selector: 'app-concentracion',
  templateUrl: './concentracion.component.html',
  styleUrl: './concentracion.component.css'
})
export class ConcentracionComponent implements OnInit {
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>' +
    '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>' +
    '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';
  private color = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A']

  private numEvaluaciones = 1;
  private numHistorico = 12;
  public idPlantilla: number = 7;
  private idAdmin: string;
  private idInst;
  public encPar: number = 0;
  public pares = [0];
  public tipo1 = "bar";
  public tipo2 = "line";
  public eje = true;
  public Filters = FiltersM;

  public Periodos = [];
  public perspectivas = [];
  public datos = [];
  public dhistorico = [];
  private saldos = []; //saldos para adicla representa nacional
  private cuentas = []; //para adicla representa extranjero
  public totales: any;
  public limites = [];
  public encabezadoMetrica = 1;
  public encPerspectiva = '';
  public ihh = 0;
  public min = 0;
  public max = 0;
  public parametros = [0, 0, 0, 0, 0];
  public txtParametro = '';
  public txtImg = '';
  public edicion = false;
  private dataAll: any; //para adicla representa la metrica de Todas
  public tituloModal = "";


  // Gráfica 1 - Combinada
  public dataGrafica1: any[] = [];
  public labelsGrafica1: string[] = [];
  public ejesYGrafica1: string[] = ['Monto', '%'];
  public tipoGraficaCombinada = typesApex.COMBO; // Para column + line
  public coloresGrafica = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A'];

  // Gráfica 2 - Histórico
  public dataGrafica2: any[] = [];
  public labelsGrafica2: string[] = [];
  public tipoGrafica2 = typesApex.STACKEDHORIZONTAL; // Bar horizontal apilado 100%

  // Variables para control de etiquetas
  public etiquetas1 = false; // Gráfica 1: Combinada
  public etiquetas2 = false; // Gráfica 2: Histórico
  public changeLabel1 = false;
  public changeLabel2 = false;

  @ViewChild('graficador1') graficador1: GraficadorComponent;
  @ViewChild('graficador2') graficador2: GraficadorComponent;
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitlesH = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public cadenaHistorico = [];

  public prefix = '';
  public suffix = 'Gs';
  public miles = ',';
  public decimal = '.';
  public precicion = 1;
  public aling = '';

  /** click izquierdo */
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  menuTopLeftPosition = { x: '0', y: '0' };
  private inputEdit;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private cdr: ChangeDetectorRef,
    private concentracionService: ConcentracionService
  ) {}

  ngOnInit(): void {
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    if (instAT ) {
      this.idPlantilla = Number(instAT.idPlantilla);
      this.getEvaluacion();
      this.encPar = this.pares[0];
    } else {
      setTimeout(() => {
        var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.idInst)).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }, 500)
    }
  }

  //consultas
  private async getEvaluacion() {
    try {
      var data;
      if(this.idPlantilla === 7){
        data = await this.concentracionService.getEvaluaciones(this.idPlantilla);
        data = data.evaluaciones;
      }else{
        data = await this.concentracionService.getPeriodosRiesgos(this.idAdmin);

        data = data.map(({period, ...resto}) => ({
          ...resto,
          fechaContable: period
        }));
      }     
      if(data.length == 0){
        var nombre = companiesRiesgoLiquidez.find(c => Number(c.id) === Number(this.idInst)).name;
        messages.infoMessageGraph(nombre + this.translate.instant('swal.instNoInfo'));
      }else{
        this.ordenamientoDataEvaluacion([].concat(data));
      }      
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();
  }
  private async getPropieties() {
    try {
      const data = await this.concentracionService.getPropiedades(this.dataService.idInstitution, "2023-01");
      const aditional = data.ahorros_sub_calculos.adicionales;
      let auxLimits = [];
      for (const periodos of aditional) {
        const fec = moment(periodos.periodo.split('T')[0]).format('DD-MM-YYYY');
        if (JSON.stringify(periodos.propiedades).includes('AHO')) {
          auxLimits.push({
            periodo: fec,
            limites: periodos.propiedades,
          });
        }
      }
      this.limites = auxLimits;
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
        } else {
          mes.check = false;
        }
      }
    }

    if ((per.check))
      this.obtenerDataEvaluacion();
  }
  //actualiza la informacion en base a la metrica 
  public cambioMetrica(metrica) {
    if(this.idPlantilla === 7){
      if (metrica == 'Saldos') {
        this.encabezadoMetrica = 1;
        this.datos = this.saldos;
      } else {
        this.encabezadoMetrica = 2;
        this.datos = this.cuentas;
      }
    }else{
      this.encabezadoMetrica =
        metrica === 'Todas' ? 1 :
        metrica === 'Nacional' ? 2 :
        metrica === 'Extranjera' ? 3 :
        0;
      this.datos = this.dataAll.find( d => d.descripcion === this.encPerspectiva)[`${this.encabezadoMetrica}`];
    }

    this.getTotales(this.datos);
    this.prepararDatosGrafica2();

  }
  //actualiza la informacion a perspectiva seleccionada 
  public cambioPerspectiva(nPerspectiva) {
    if(this.idPlantilla === 7){
      this.encPerspectiva = this.perspectivas[nPerspectiva];
      //this.obtenerDataEvaluacion();
      // this.getTabla(this.dataAll);
      this.getDatos();
    }else{
      this.encPerspectiva = this.perspectivas[nPerspectiva].name;
      this.datos = this.dataAll.find( d => d.descripcion === this.encPerspectiva)[`${this.encabezadoMetrica}`];
      this.getTotales(this.datos);
    }
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.cadenaHistorico = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].utilizable) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check || (tot > 0 && tot < this.numHistorico)) {
            this.cadenaEvaluacion.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes),
              mes: this.Periodos[i].series[j].nmes,
              anio: this.Periodos[i].series[j].an,
            });
            tot++;
          }
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;

    tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      if (this.Periodos[i].utilizable) {
        for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
          if (this.Periodos[i].series[j].check || (tot > 0 && tot < this.numHistorico)) {
            this.cadenaHistorico.push({
              evaluacion: this.Periodos[i].series[j].periodo,
              idEvaluacion: this.Periodos[i].series[j].id,
              porcentaje: '%',
              pos: this.Periodos[i].series[j].pos,
              periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes),
              mes: this.Periodos[i].series[j].nmes,
              anio: this.Periodos[i].series[j].an,
            });
            tot++;
          }
        }
      }
    }
    this.getPerspectivas();
    this.idPlantilla === 7 ? this.getPropieties() : '';
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }
  //Obtiene las perspectivas de acuerdo al periodo
  public async getPerspectivas() {
    switch(this.idPlantilla){
      case 7: 
        this.perspectivas = perspectivas.sort();
        this.encPerspectiva = this.perspectivas[0];
        this.getDatos();
        break;
      case 12: 
        this.perspectivas = [
          {identifier: 'entity', name: 'Entidad'},
          {identifier: 'expiration', name: 'Vencimiento'}
        ]
        this.encPerspectiva = this.perspectivas[0].name;
        this.getDatosRiesgos();
        break
    } 
  }
  //Obtiene los datos de la perspectiva
  public async getDatos() {
    const encPerspectiva = this.encPerspectiva.split(" ")[0];
    if (encPerspectiva === 'Depositos') {
      await this.fetchDepositosData();
    } else if (encPerspectiva === 'Productos') {
      await this.fetchProductosData();
    } else if (encPerspectiva === 'Saldo') {
      await this.fetchSaldosData();
    }
  }

  dataHistorico = [];
  public async getDatosRiesgos(){
    try{
      const data = await this.concentracionService.getConcentracionLiquidez(this.idAdmin, this.cadenaEvaluacion[0].anio, this.cadenaEvaluacion[0].mes);
      const dataPer = this.perspectivas.map( p =>{
        const sinDup = this.agruparSegmentos(data[p['identifier']].segments);
        const tot1 = sinDup.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
        const met1 = data[p['identifier']].segments.filter( d => d.moneda === 'Nacional');
        const tot2 = met1.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
        const met2 = data[p['identifier']].segments.filter( d => d.moneda === 'Extranjera');
        const tot3 = met2.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
        return {
          perspective: p['identifier'],
          descripcion: p['name'],
          1: sinDup.map( d =>{
            return {
              monto: d.saldo,
              descripcion: d.segment,
              promedio: 0,
              porcentaje: d.saldo/tot1,
              min: d.limits.min??0,
              max: d.limits.max??0,
            }
          }),
          2: met1.map( d =>{
            return {
              monto: d.saldo,
              descripcion: d.segment,
              promedio: 0,
              porcentaje: d.saldo/tot2,
              min: d.limits.min??0,
              max: d.limits.max??0,
            }
          }),
          3: met2.map( d =>{
            return {
              monto: d.saldo,
              descripcion: d.segment,
              promedio: 0,
              porcentaje: d.saldo/tot3,
              min: d.limits.min??0,
              max: d.limits.max??0,
            }
          }),
        }
      });

      const historicalPromises = this.cadenaHistorico.map(i =>
        this.concentracionService.getConcentracionLiquidez(this.idAdmin, i.anio, i.mes)
      );

      const historicalResults = await Promise.all(historicalPromises);

      this.dataHistorico = historicalResults.map( h =>{
        return this.perspectivas.map( p =>{
          const sinDup = this.agruparSegmentos(data[p['identifier']].segments);
          const tot1 = sinDup.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
          const met1 = h[p['identifier']].segments.filter( d => d.moneda === 'Nacional');
          const tot2 = met1.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
          const met2 = h[p['identifier']].segments.filter( d => d.moneda === 'Extranjera');
          const tot3 = met2.reduce( (acc, d) => acc + (d.saldo ?? 0), 0);
          return {
            perspective: p['identifier'],
            descripcion: p['name'],
            1: sinDup.map( d =>{
              return {
                monto: d.saldo,
                descripcion: d.segment,
                promedio: 0,
                porcentaje: d.saldo/tot1,
                min: d.limits.min??0,
                max: d.limits.max??0,
              }
            }),
            2: met1.map( d =>{
              return {
                monto: d.saldo,
                descripcion: d.segment,
                promedio: 0,
                porcentaje: d.saldo/tot2,
                min: d.limits.min??0,
                max: d.limits.max??0,
              }
            }),
            3: met2.map( d =>{
              return {
                monto: d.saldo,
                descripcion: d.segment,
                promedio: 0,
                porcentaje: d.saldo/tot3,
                min: d.limits.min??0,
                max: d.limits.max??0,
              }
            }),
          }
        });
      });
      this.dataAll = [].concat(dataPer);
      this.datos = this.dataAll.find( d => d.descripcion === this.encPerspectiva)[`${this.encabezadoMetrica}`];
      this.getTotales(this.datos);
    }catch(e){
      messages.errorMessageGraph(e);
    }
  }
  private agruparSegmentos(segments: any[]) {
    const map = new Map<string, any>();
    segments.forEach(seg => {
      const key = seg.segment;
      if (!map.has(key)) {
        map.set(key, {
          ...seg,
          saldo: seg.saldo
        });
      } else {
        map.get(key).saldo += seg.saldo;
      }
    });

    return Array.from(map.values());
  } 

  private async fetchApolloData(queryType: string, periodo: string) {
    try {
      let data;
      switch (queryType) {
        case 'plazo':
          data = await this.concentracionService.getDataPlazo(periodo);
          break;
        case 'producto':
          data = await this.concentracionService.getDataProducto(periodo);
          break;
        case 'saldo':
          data = await this.concentracionService.getDataSaldo(periodo);
          break;
        default:
          throw new Error('Tipo de query no válido');
      }
      return data;
    } catch (error) {
      messages.errorMessageGraph(error);
      throw error;
    }
  }

  private async fetchDepositosData() {
    try {
      const data = await this.fetchApolloData(
        'plazo',
        this.cadenaEvaluacion[0].periodo
      );

      const d = data.ahorros_sub_calculos.AHO_12;
      var sumSaldo = 0, sumCuentas = 0;

      // --- CÁLCULO DE SUMAS TOTALES ---
      sumSaldo = d.de_1_30.totalSaldo + d.de_31_60.totalSaldo + d.de_61_90.totalSaldo + d.de_91_180.totalSaldo + d.de_181_360.totalSaldo + d.mas_360.totalSaldo +
        d.de_1_30.totalIntereses + d.de_31_60.totalIntereses + d.de_61_90.totalIntereses + d.de_91_180.totalIntereses + d.de_181_360.totalIntereses + d.mas_360.totalIntereses;
      sumCuentas = d.de_1_30.totalCuentas + d.de_31_60.totalCuentas + d.de_61_90.totalCuentas + d.de_91_180.totalCuentas + d.de_181_360.totalCuentas + d.mas_360.totalCuentas;

      // --- LLENADO DE SALDOS (AUX) ---
      var aux = [];
      aux.push({
        descripcion: '<= a 30 días',
        id: 'de_1_30',
        promedio: (d.de_1_30.totalSaldo + d.de_1_30.totalIntereses) / d.de_1_30.totalCuentas,
        monto: d.de_1_30.totalSaldo + d.de_1_30.totalIntereses,
        porcentaje: (d.de_1_30.totalSaldo + d.de_1_30.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '31 0 60 días',
        id: 'de_31_60',
        promedio: (d.de_31_60.totalSaldo + d.de_31_60.totalIntereses) / d.de_31_60.totalCuentas,
        monto: d.de_31_60.totalSaldo + d.de_31_60.totalIntereses,
        porcentaje: (d.de_31_60.totalSaldo + d.de_31_60.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '61 a 90 días',
        id: 'de_61_90',
        promedio: (d.de_61_90.totalSaldo + d.de_61_90.totalIntereses) / d.de_61_90.totalCuentas,
        monto: d.de_61_90.totalSaldo + d.de_61_90.totalIntereses,
        porcentaje: (d.de_61_90.totalSaldo + d.de_61_90.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '91 a 180 días',
        id: 'de_91_180',
        promedio: (d.de_91_180.totalSaldo + d.de_91_180.totalIntereses) / d.de_91_180.totalCuentas,
        monto: d.de_91_180.totalSaldo + d.de_91_180.totalIntereses,
        porcentaje: (d.de_91_180.totalSaldo + d.de_91_180.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '181 a 360 días',
        id: 'de_181_360',
        promedio: (d.de_181_360.totalSaldo + d.de_181_360.totalIntereses) / d.de_181_360.totalCuentas,
        monto: d.de_181_360.totalSaldo + d.de_181_360.totalIntereses,
        porcentaje: (d.de_181_360.totalSaldo + d.de_181_360.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '> 360 días',
        id: 'mas_360',
        promedio: (d.mas_360.totalSaldo + d.mas_360.totalIntereses) / d.mas_360.totalCuentas,
        monto: d.mas_360.totalSaldo + d.mas_360.totalIntereses,
        porcentaje: (d.mas_360.totalSaldo + d.mas_360.totalIntereses) / sumSaldo,
        min: 0,
        max: 0,
        rango: ''
      });
      this.saldos = aux;

      // --- LLENADO DE CUENTAS (AUX) ---
      var aux = [];
      aux.push({
        descripcion: '<= a 30 días',
        id: 'de_1_30',
        promedio: (d.de_1_30.totalSaldo + d.de_1_30.totalIntereses) / d.de_1_30.totalCuentas,
        monto: d.de_1_30.totalCuentas,
        porcentaje: d.de_1_30.totalCuentas / sumCuentas,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '31 a 60 días',
        id: 'de_31_60',
        promedio: (d.de_31_60.totalSaldo + d.de_31_60.totalIntereses) / d.de_31_60.totalCuentas,
        monto: d.de_31_60.totalCuentas,
        porcentaje: d.de_31_60.totalCuentas / sumCuentas,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '61 a 90 días',
        id: 'de_61_90',
        promedio: (d.de_61_90.totalSaldo + d.de_61_90.totalIntereses) / d.de_61_90.totalCuentas,
        monto: d.de_61_90.totalCuentas,
        porcentaje: d.de_61_90.totalCuentas / sumCuentas,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '91 a 180 días',
        id: 'de_91_180',
        promedio: (d.de_91_180.totalSaldo + d.de_91_180.totalIntereses) / d.de_91_180.totalCuentas,
        monto: d.de_91_180.totalCuentas,
        porcentaje: d.de_91_180.totalCuentas / sumCuentas,
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '181 a 360 días',
        id: 'de_181_360',
        promedio: (d.de_181_360.totalSaldo + d.de_181_360.totalIntereses) / d.de_181_360.totalCuentas,
        monto: d.de_181_360.totalCuentas,
        porcentaje: (d.de_181_360.totalCuentas / sumCuentas),
        min: 0,
        max: 0,
        rango: ''
      });
      aux.push({
        descripcion: '> 360 días',
        id: 'mas_360',
        promedio: (d.mas_360.totalSaldo + d.mas_360.totalIntereses) / d.mas_360.totalCuentas,
        monto: d.mas_360.totalCuentas,
        porcentaje: d.mas_360.totalCuentas / sumCuentas,
        min: 0,
        max: 0,
        rango: ''
      });
      this.cuentas = aux;

      // --- ASIGNACIÓN Y CÁLCULOS FINALES ---
      this.datos = this.encabezadoMetrica == 1 ? this.saldos : this.cuentas;
      this.getTotales(this.datos);
      for (let index = 0; index < this.datos.length; index++) {
        this.enRango(index);
      }

      // 2. Obtener datos históricos (Usando Promise.all para paralelismo)
      const historicalPromises = this.cadenaHistorico.map(i =>
        this.fetchApolloData('plazo', i.periodo)
      );

      const historicalResults = await Promise.all(historicalPromises);

      // --- INICIALIZACIÓN DEL HISTÓRICO ---
      var historico = [
        { name: '<= a 30 días', saldos: [], cuentas: [] },
        { name: '31 a 60 días', saldos: [], cuentas: [] },
        { name: '61 a 90 días', saldos: [], cuentas: [] },
        { name: '91 a 180 días', saldos: [], cuentas: [] },
        { name: '181 a 360 días', saldos: [], cuentas: [] },
        { name: '> 360 días', saldos: [], cuentas: [] },
        { periodos: [] } // Elemento [6] para los periodos
      ];

      // --- PROCESAMIENTO DEL HISTÓRICO ---
      historicalResults.forEach((data, index) => {
        const i = this.cadenaHistorico[index];
        const d = data.ahorros_sub_calculos.AHO_12;

        // Recalcular sumas totales para cada período histórico
        var sumSaldoPeriodo = d.de_1_30.totalSaldo + d.de_31_60.totalSaldo + d.de_61_90.totalSaldo + d.de_91_180.totalSaldo + d.de_181_360.totalSaldo + d.mas_360.totalSaldo +
          d.de_1_30.totalIntereses + d.de_31_60.totalIntereses + d.de_61_90.totalIntereses + d.de_91_180.totalIntereses + d.de_181_360.totalIntereses + d.mas_360.totalIntereses;
        var sumCuentasPeriodo = d.de_1_30.totalCuentas + d.de_31_60.totalCuentas + d.de_61_90.totalCuentas + d.de_91_180.totalCuentas + d.de_181_360.totalCuentas + d.mas_360.totalCuentas;

        historico[6].periodos.push(i.evaluacion); // Guarda el nombre del período

        // Llenar datos históricos (posiciones 0 a 5)
        historico[0].saldos.push((d.de_1_30.totalSaldo + d.de_1_30.totalIntereses) / sumSaldoPeriodo);
        historico[0].cuentas.push(d.de_1_30.totalCuentas / sumCuentasPeriodo);

        historico[1].saldos.push((d.de_31_60.totalSaldo + d.de_31_60.totalIntereses) / sumSaldoPeriodo);
        historico[1].cuentas.push(d.de_31_60.totalCuentas / sumCuentasPeriodo);

        historico[2].saldos.push((d.de_61_90.totalSaldo + d.de_61_90.totalIntereses) / sumSaldoPeriodo);
        historico[2].cuentas.push(d.de_61_90.totalCuentas / sumCuentasPeriodo);

        historico[3].saldos.push((d.de_91_180.totalSaldo + d.de_91_180.totalIntereses) / sumSaldoPeriodo);
        historico[3].cuentas.push(d.de_91_180.totalCuentas / sumCuentasPeriodo);

        historico[4].saldos.push((d.de_181_360.totalSaldo + d.de_181_360.totalIntereses) / sumSaldoPeriodo);
        historico[4].cuentas.push(d.de_181_360.totalCuentas / sumCuentasPeriodo);

        historico[5].saldos.push((d.mas_360.totalSaldo + d.mas_360.totalIntereses) / sumSaldoPeriodo);
        historico[5].cuentas.push(d.mas_360.totalCuentas / sumCuentasPeriodo);
      });

      this.dhistorico = historico;
      this.prepararDatosGrafica1();
      this.prepararDatosGrafica2();
    } catch (error) {

    }
  }

  private async fetchProductosData() {
    try {
      const data = await this.fetchApolloData(
        'producto',
        this.cadenaEvaluacion[0].periodo
      );

      const d: any[] = data.ahorros_sub_calculos.AHO_13;
      var sumSaldo = 0, sumCuentas = 0;

      // --- CÁLCULO DE SUMAS TOTALES ACTUALES ---
      for (const i of d) {
        sumSaldo += i.totalSaldo;
        sumCuentas += i.totalCuentas;
      }

      // --- LLENADO DE SALDOS (this.saldos) ---
      var aux = [];
      for (const i of d) {
        aux.push({
          descripcion: i.descripcion,
          id: i.id,
          promedio: (i.totalSaldo + i.totalIntereses) / i.totalCuentas,
          monto: i.totalSaldo + i.totalIntereses,
          porcentaje: (i.totalSaldo + i.totalIntereses) / sumSaldo,
          min: 0,
          max: 0,
          rango: ''
        });
      }
      this.saldos = aux;

      // --- LLENADO DE CUENTAS (this.cuentas) ---
      aux = [];
      for (const i of d) {
        aux.push({
          descripcion: i.descripcion,
          id: i.id,
          promedio: (i.totalSaldo + i.totalIntereses) / i.totalCuentas,
          monto: i.totalCuentas,
          porcentaje: i.totalCuentas / sumCuentas,
          min: 0,
          max: 0,
          rango: ''
        });
      }
      this.cuentas = aux;

      // --- ASIGNACIÓN Y CÁLCULOS FINALES ---
      this.datos = this.encabezadoMetrica == 1 ? this.saldos : this.cuentas;
      this.getTotales(this.datos);
      for (let index = 0; index < this.datos.length; index++) {
        this.enRango(index);
      }

      // 2. Obtener datos históricos (Usando Promise.all para paralelismo)
      const historicalPromises = this.cadenaHistorico.map(i =>
        this.fetchApolloData('producto', i.periodo)
      );

      const historicalResults = await Promise.all(historicalPromises);

      // --- INICIALIZACIÓN DEL HISTÓRICO ---
      var historico = [
        { name: 'A la vista', saldos: [], cuentas: [] },
        { name: 'A plazo fijo', saldos: [], cuentas: [] },
        { name: 'Infanto juvenil', saldos: [], cuentas: [] },
        { name: 'Suspenso', saldos: [], cuentas: [] },
        { name: 'Planificado', saldos: [], cuentas: [] },
        { periodos: [] }
      ];

      // --- PROCESAMIENTO DEL HISTÓRICO ---
      historicalResults.forEach((data, index) => {
        const i = this.cadenaHistorico[index];
        const d: any[] = data.ahorros_sub_calculos.AHO_13;

        // Recalcular sumas totales para cada período histórico
        var sumSaldoPeriodo = 0, sumCuentasPeriodo = 0;
        for (const item of d) {
          sumSaldoPeriodo += item.totalSaldo + item.totalIntereses;
          sumCuentasPeriodo += item.totalCuentas;
        }

        historico[historico.length - 1].periodos.push(i.evaluacion); // Guarda el nombre del período

        // Llenar datos históricos (iterando sobre 'd')
        var l = 0;
        for (const j of d) {
          // Llenado de saldos (porcentaje)
          historico[l].saldos.push((j.totalSaldo + j.totalIntereses) / sumSaldoPeriodo);
          // Llenado de cuentas (porcentaje)
          historico[l].cuentas.push(j.totalCuentas / sumCuentasPeriodo);
          l++;
        }
      });

      this.dhistorico = historico;
      this.prepararDatosGrafica1();
      this.prepararDatosGrafica2();

    } catch (error) {
      // Manejo de errores (puedes agregar lógica específica aquí si es necesario)
      // this.errorMessageGraph(error); // Asumiendo que esta es tu función de manejo de errores
    }
  }

  private async fetchSaldosData() {
    try {
      // 1. Obtener datos de la evaluación actual (Bloque principal)
      const data = await this.fetchApolloData(
        'saldo',
        this.cadenaEvaluacion[0].periodo
      );

      const d: any[] = data.ahorros_sub_calculos.AHO_11;
      var sumSaldo = 0, sumCuentas = 0;

      // --- CÁLCULO DE SUMAS TOTALES ACTUALES ---
      for (const i of d) {
        sumSaldo += i.totalSaldo + i.totalIntereses;
        sumCuentas += i.totalCuentas;
      }

      // --- LLENADO DE SALDOS (this.saldos) ---
      var aux = [];
      for (const i of d) {
        aux.push({
          descripcion: i.descripcion,
          id: i.id,
          promedio: (i.totalSaldo + i.totalIntereses) / i.totalCuentas,
          monto: i.totalSaldo + i.totalIntereses,
          porcentaje: (i.totalSaldo + i.totalIntereses) / sumSaldo,
          min: 0,
          max: 0,
          rango: ''
        });
      }
      this.saldos = aux;

      // --- LLENADO DE CUENTAS (this.cuentas) ---
      aux = [];
      for (const i of d) {
        aux.push({
          descripcion: i.descripcion,
          id: i.id,
          promedio: (i.totalSaldo + i.totalIntereses) / i.totalCuentas,
          monto: i.totalCuentas,
          porcentaje: i.totalCuentas / sumCuentas,
          min: 0,
          max: 0,
          rango: ''
        });
      }
      this.cuentas = aux;

      // --- ASIGNACIÓN Y CÁLCULOS FINALES ---
      this.datos = this.encabezadoMetrica == 1 ? this.saldos : this.cuentas;
      this.getTotales(this.datos);
      for (let index = 0; index < this.datos.length; index++) {
        this.enRango(index);
      }

      // 2. Obtener datos históricos (Usando Promise.all para paralelismo)
      const historicalPromises = this.cadenaHistorico.map(i =>
        this.fetchApolloData('saldo', i.periodo)
      );

      const historicalResults = await Promise.all(historicalPromises);

      // --- INICIALIZACIÓN DEL HISTÓRICO (CORRECCIÓN TS2345) ---
      // 1. Declaración con Unión de Tipos
      var historico: (HistoricalDataItem | HistoricalPeriodItem)[] = d.map(item => ({
        name: item.descripcion,
        saldos: [],
        cuentas: []
      }));

      // 2. Inserción del objeto 'periodos' con afirmación de tipo
      historico.push({ periodos: [] } as HistoricalPeriodItem);

      // --- PROCESAMIENTO DEL HISTÓRICO ---
      historicalResults.forEach((data, index) => {
        const i = this.cadenaHistorico[index];
        const d: any[] = data.ahorros_sub_calculos.AHO_11;

        // Recalcular sumas totales para cada período histórico
        var sumSaldoPeriodo = 0, sumCuentasPeriodo = 0;
        for (const item of d) {
          sumSaldoPeriodo += item.totalSaldo + item.totalIntereses;
          sumCuentasPeriodo += item.totalCuentas;
        }

        // 3. Acceso a 'periodos' con afirmación de tipo
        (historico[historico.length - 1] as HistoricalPeriodItem).periodos.push(i.evaluacion);

        // Llenar datos históricos (CORRECCIÓN TS2339)
        for (let l = 0; l < d.length; l++) {
          const j = d[l];

          // 4. Afirmación de tipo para asegurar que el elemento tiene 'saldos' y 'cuentas'
          const itemData = historico[l] as HistoricalDataItem;

          // Llenado de saldos (porcentaje)
          itemData.saldos.push((j.totalSaldo + j.totalIntereses) / sumSaldoPeriodo);
          // Llenado de cuentas (porcentaje)
          itemData.cuentas.push(j.totalCuentas / sumCuentasPeriodo);
        }
      });

      this.dhistorico = historico;
      this.prepararDatosGrafica1();
      this.prepararDatosGrafica2();

    } catch (error) {
    }
  }
  public getTotales(datos) {
    var aux = {
      descripcion: 'Total',
      promedio: 0,
      monto: 0,
      porcentaje: 0,
      min: '',
      max: '',
      rango: ''
    };
    var ihh = 0;
    for (var i = 0; i < datos.length; i++) {
      aux.promedio += datos[i].promedio;
      aux.monto += datos[i].monto;
      aux.porcentaje += datos[i].porcentaje;
      ihh += Math.pow(datos[i].porcentaje, 2);
    }
    //this.datos.push(aux);
    aux.promedio = aux.promedio / datos.length
    this.totales = aux;
    ihh = ihh * 10000;
    this.ihh = ihh;

    //Calculo de min y max del IHH
    this.min = (1 / datos.length) * 10000;
    this.max = this.min * (datos.length * 0.60);

    //Calculo de parametros por cooperativa
    // this.parametros[0] = this.min;
    // this.parametros[1] = ((this.max - this.min) / 4) + this.parametros[0];
    // this.parametros[2] = ((this.max - this.min) / 4) + this.parametros[1];
    // this.parametros[3] = ((this.max - this.min) / 4) + this.parametros[2];
    // this.parametros[4] = this.max;
    this.parametros[0] = 1000;
    this.parametros[1] = 2000;
    this.parametros[2] = 3500;
    this.parametros[3] = 5000;
    this.parametros[4] = 5000;

    const cuenta = (1/datos.length)
    const divisor = (1-cuenta)
    const newIhh = (((ihh/10000)-cuenta)/divisor)*10000;

    this.parametroIHH(newIhh);
    this.prepararDatosGrafica1();
    this.prepararDatosGrafica2();
  }
  private prepararDatosGrafica1() {
    if (!this.datos || this.datos.length === 0) {
      return;
    }

    // Preparar labels
    this.labelsGrafica1 = [];
    const montos = [];
    const porcentajes = [];

    this.datos.forEach((item) => {
      if (item.descripcion !== 'Total') {
        this.labelsGrafica1.push(item.descripcion);
        montos.push(item.monto || 0);
        porcentajes.push(parseFloat(((item.porcentaje || 0) * 100).toFixed(1)));
      }
    });

    // Preparar data
    const etiqueta = this.encabezadoMetrica === 1 ? 'Monto' : 'Cuentas';

    if (this.tipoGraficaCombinada === typesApex.COMBO) {
      // Gráfica COMBINADA: incluir "type" en cada serie
      this.dataGrafica1 = [
        {
          name: etiqueta,
          data: montos,
          type: this.tipo1  
        },
        {
          name: '%',
          data: porcentajes,
          type: this.tipo2  
        }
      ];
    } else {
      // Gráfica SIMPLE: NO incluir "type"
      this.dataGrafica1 = [
        {
          name: etiqueta,
          data: montos
          
        },
        {
          name: '%',
          data: porcentajes
          
        }
      ];
    }
  }
  private prepararDatosGrafica2() {
    // Preparar data
    this.dataGrafica2 = [];

    if(this.idPlantilla === 7){
      if (!this.dhistorico || this.dhistorico.length === 0) {
        return;
      }
      // Preparar labels (periodos)
      this.labelsGrafica2 = this.dhistorico[this.dhistorico.length - 1].periodos || [];

      // Preparar subtítulo
      const etiquetas = this.labelsGrafica2;
      this.subTitlesH = etiquetas[etiquetas.length - 1] + ' - ' + etiquetas[0];

      for (let i = 0; i < this.dhistorico.length - 1; i++) {
        const item = this.dhistorico[i];
        const metricData = this.encabezadoMetrica === 1 ? item.saldos : item.cuentas;

        // Convertir a porcentaje
        const dataEnPorcentaje = metricData.map(val => parseFloat((val * 100).toFixed(1)));

        this.dataGrafica2.push({
          name: item.name,
          data: dataEnPorcentaje
        });
      }
    }else{
      this.labelsGrafica2 = [];
      const aux = this.cadenaHistorico.map(h =>{
      //TODO: Hacer que se haga automatico
        this.labelsGrafica2.push(h.evaluacion);
        const etiquetas = this.dataHistorico[0].find( d => d.descripcion === this.encPerspectiva)[`${this.encabezadoMetrica}`].map( s => s.descripcion);
        const data = this.dataHistorico[0].find( d => d.descripcion === this.encPerspectiva)[`${this.encabezadoMetrica}`].map( s =>{ return {name: s.descripcion, data: s.monto}});
        return {
          period: h.evaluacion,
          data
        }
      });
      this.subTitlesH = 'ago 25';

      const map = new Map<string, number[]>();
      aux.forEach(periodo => {
        periodo.data.forEach(seg => {
          if (!map.has(seg.name)) {
            map.set(seg.name, []);
          }
          map.get(seg.name)!.push(seg.data);
        });
      });

      this.dataGrafica2 = Array.from(map.entries()).map(([name, data]) => ({
        name,
        data
      }));
    }
  }
  //calcular el parametro IHH 
  public parametroIHH(num) {
    var txt = '';
    if (num <= this.parametros[1]) {
      txt = 'BAJA';
      this.txtImg = 'baja'
    } else if (num > this.parametros[1] && num <= this.parametros[2]) {
      txt = 'MEDIO BAJA'
      this.txtImg = 'mediaBaja'
    } else if (num > this.parametros[2] && num <= this.parametros[3]) {
      txt = 'MEDIA'
      this.txtImg = 'media'
    } else if (num > this.parametros[3] && num <= this.parametros[4]) {
      txt = 'MEDIO ALTA'
      this.txtImg = 'mediaAlta'
    } else if (num > this.parametros[4]) {
      txt = 'ALTA'
      this.txtImg = 'alta'
    } else {
      txt = 'Sin datos';
      this.txtImg = 'baja';
    }
    this.txtParametro = txt;
  }


  //espcificaciones de la grafica recibe dos variables tipo de grafica a mostrar
  public cambiarTipoGrafica1(tipo1: string, tipo2: string) {
    this.tipo1 = tipo1;
    this.tipo2 = tipo2;

    // Determinar el tipo de gráfica
    if (tipo1 !== tipo2) {
      // Tipos DIFERENTES → COMBO
      this.tipoGraficaCombinada = typesApex.COMBO;
    } else {
      // Tipos IGUALES → Tipo específico
      switch (tipo1) {
        case 'bar':
          this.tipoGraficaCombinada = typesApex.BAR;
          break;
        case 'line':
          this.tipoGraficaCombinada = typesApex.LINE;
          break;
        case 'area':
          this.tipoGraficaCombinada = typesApex.AREA;
          break;
        default:
          this.tipoGraficaCombinada = typesApex.COMBO;
      }
    }

    this.prepararDatosGrafica1();
  }

  public cambiarTipoGrafica2(horizontal: boolean) {
    this.eje = horizontal;
    this.tipoGrafica2 = horizontal ? typesApex.STACKEDHORIZONTAL : typesApex.STACKED;
    this.prepararDatosGrafica2();
  }
  //ampliar la grafica 
  public ampliarGraf(graf: string) {
    this.tituloModal = graf;
    document.getElementById("ampliar")!.style.display = "block";

  }
  //Cerrar modal ampliar grafica
  public closeModal() {
    document.getElementById("ampliar")!.style.display = "none";
  }
  //detecta el click fuera del modal y cierra 
  public clickFuera(event) {
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }
  /*Formateo de cantidades recibe el numero a formatear 
  y true para decimales false sin decimales */
  public formatoNum(num, dec) {
    if (num !== undefined && num !== '') {
      return CommonVariables.formatearMoneda(num, dec, this.miles, this.decimal);
    }
    return '';
  }
  // eventos input
  public async actualizarLimits(prop, limite) {
    var inputValue = this.obtLimit(prop, limite);
    var introdujo: any, guardo = false;

    let texto = '';
    if (limite === 'min') {
      texto = 'mínimo';
    } else {
      texto = 'máximo';
    }

    introdujo = await Swal.fire({
      title: 'Ingresa el procentaje ' + texto,
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      if (this.encPerspectiva !== 'Productos') {
        this.actLimites(prop, limite, introdujo.value);
      } else {
        this.obtLimitesArreglo(prop, limite, introdujo.value);
      }
    } else {
      messages.errorMessageGraph('swal.swalNoGuardo');
    }
  }
  // Guarda el nuevo limite del rango, recibe el nuevo dato y el limite a actualizar (min o max) para aho 11 y 12
  private async actLimites(i, limite, valor) {
    let lim = this.obtLimitJson();
    let nuevoPerido = false;
    var periodo = moment(FuncionesMes.escrituraPer(this.subTitles)).format('YYYY-MM');
    let Json: any;
    var pers = '';
    var met = '';

    if (this.encPerspectiva !== 'Saldo') {
      pers = 'AHO_12';
    } else {
      pers = 'AHO_11';
    }
    if (this.encabezadoMetrica === 1) {
      met = 'totalSaldo';
    } else {
      met = 'totalCuentas';
    }

    if (lim !== undefined) {
      let nuevo = JSON.parse(JSON.stringify(lim.limites));
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": { ' + this.obtenerProp(met, limite, i, valor, undefined) + ' } }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse('{ ' + this.obtenerProp(met, limite, i, valor, nuevo[pers]) + ' } ');
        nuevo[pers] = nnn;
      }
      lim.limites = nuevo;
      Json = nuevo;
    } else {
      const cop = this.obtLimitJsonCopia();
      let nuevo;
      if (cop !== undefined) {
        nuevo = JSON.parse(JSON.stringify(cop.limites));
      } else {
        nuevo = JSON.parse('{ "' + pers + '": { ' + this.obtenerProp(met, limite, i, valor, undefined) + ' } }');
      }
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": { ' + this.obtenerProp(met, limite, i, valor, undefined) + ' } }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse('{ ' + this.obtenerProp(met, limite, i, valor, nuevo[pers]) + ' } ');
        nuevo[pers] = nnn;
      }
      nuevoPerido = true;
      Json = nuevo;
    }
    try {
      await this.concentracionService.setLimites(periodo, Json, "6463f46b5a452a0012fa8f38");
      if (nuevoPerido) {
        this.limites.push({
          periodo: moment(periodo + '-01', "YYYY-MM-DD").format("DD-MM-YYYY"),
          limites: Json
        });
      }
      messages.succesMessageGraph('swal.swalGuardo');
    } catch (error) {

    }
  }
  private obtenerProp(met, lim, dat, valor, info) {
    let perspec;
    if (info === undefined) {
      perspec = '"' + dat.id + '": { ' + this.obtenerMet(lim, met, valor, undefined) + ' }';
    } else {
      if (info[dat.id] === undefined) {
        perspec = '"' + dat.id + '": { ' + this.obtenerMet(lim, met, valor, undefined) + ' }';
        perspec = perspec + ',' + JSON.stringify(info).substring(1, JSON.stringify(info).length - 1);
      } else {
        let n = JSON.parse(JSON.stringify(info));
        n[dat.id] = JSON.parse('{ ' + this.obtenerMet(lim, met, valor, info[dat.id]) + ' }');
        perspec = JSON.stringify(n).substring(1, JSON.stringify(n).length - 1);
      }
    }
    return perspec;
  }
  private obtenerMet(lim, met, valor, info) {
    let perspec;
    if (info === undefined) {
      perspec = '"' + met + '": { ' + this.obtenerLim(lim, valor, undefined) + ' }';
    } else {
      if (info[met] === undefined) {
        perspec = '"' + met + '": { ' + this.obtenerLim(lim, valor, undefined) + ' }';
        perspec = perspec + ',' + JSON.stringify(info).substring(1, JSON.stringify(info).length - 1);
      } else {
        let n = JSON.parse(JSON.stringify(info));
        n[met] = JSON.parse('{ ' + this.obtenerLim(lim, valor, info[met]) + ' }');
        perspec = JSON.stringify(n).substring(1, JSON.stringify(n).length - 1);
      }
    }
    return perspec;
  }
  private obtenerLim(lim, valor, info) {
    let perspec;
    if (info === undefined) {
      if (lim === 'min') {
        perspec = '"limits": { "min": ' + valor + ', "max": 0 }';
      } else {
        perspec = '"limits": { "min": 0, "max": ' + valor + ' }';
      }
    } else {
      if (lim === 'min') {
        perspec = '"limits": { "min": ' + valor + ', "max": ' + info['limits'].max + ' }';
      } else {
        perspec = '"limits": { "min": ' + info['limits'].min + ', "max": ' + valor + ' }';
      }
    }
    return perspec;
  }
  // Limites aho 13
  private async obtLimitesArreglo(i, limite, valor) {
    let lim = this.obtLimitJson();
    let nuevoPerido = false;
    var periodo = moment(FuncionesMes.escrituraPer(this.subTitles)).format('YYYY-MM'), Json;

    var pers = 'AHO_13';
    var met = '';

    if (this.encabezadoMetrica === 1) {
      met = 'totalSaldo';
    } else {
      met = 'totalCuentas';
    }

    if (lim !== undefined) {
      let nuevo = JSON.parse(JSON.stringify(lim.limites));
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(met, limite, i, valor, undefined) + ' }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse(this.obtenerArrayLim(met, limite, i, valor, nuevo[pers]));
        nuevo[pers] = nnn;
      }
      lim.limites = nuevo;
      Json = nuevo;
    } else {
      const cop = this.obtLimitJsonCopia();
      let nuevo;
      if (cop !== undefined) {
        nuevo = JSON.parse(JSON.stringify(cop.limites));
      } else {
        nuevo = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(met, limite, i, valor, undefined) + ' }');
      }
      /* --------------- */
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(met, limite, i, valor, undefined) + ' }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse(this.obtenerArrayLim(met, limite, i, valor, nuevo[pers]));
        nuevo[pers] = nnn;
      }
      nuevoPerido = true;
      Json = nuevo;

    }
    try {
      await this.concentracionService.setLimites(periodo, Json, "6463f46b5a452a0012fa8f38");
      if (nuevoPerido) {
        this.limites.push({
          periodo: moment(periodo + '-01', "YYYY-MM-DD").format("DD-MM-YYYY"),
          limites: Json
        });
      }
      messages.succesMessageGraph('swal.swalGuardo');

    } catch (error) {

    }
  }
  private obtenerArrayLim(met, lim, dat, valor, info) {
    let perspec = [];
    if (info === undefined) {
      perspec.push({
        codigoTipoCuenta: dat.id,
        totalCuentas: {
          limits: {
            max: 0,
            min: 0
          }
        },
        totalSaldo: {
          limits: {
            max: 0,
            min: 0
          }
        }
      });
    } else {
      let d = info.filter(d => d.codigoTipoCuenta === dat.id);
      perspec = JSON.parse(JSON.stringify(info));
      if (d.length === 0) {
        perspec.push({
          codigoTipoCuenta: dat.id,
          totalCuentas: {
            limits: {
              max: 0,
              min: 0
            }
          },
          totalSaldo: {
            limits: {
              max: 0,
              min: 0
            }
          }
        });
      }
    }
    let ex = perspec.filter(d => d.codigoTipoCuenta === dat.id);
    ex[0][met]['limits'][lim] = Number(valor);
    return JSON.stringify(perspec);
  }
  //obtiene el arreglo de limites del periodo
  public obtLimitJson() {
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSame(pS)) {
        return p;
      }
    }
    return undefined;
  }
  public obtLimitJsonCopia() {
    let exis = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        if (exis === undefined) {
          exis = p;
        } else if (moment(exis.periodo).isSameOrBefore(moment(p.periodo))) {
          exis = p;
        }
      }
    }
    return exis;
  }
  //obtiene el valor del lim ya sea min o max
  public obtLimit(prop, lim, form?) {
    let limite;
    if (this.encPerspectiva !== 'Productos') {
      limite = this.obtLimitN(prop, lim, form);
    } else {
      limite = this.obtLimitO(prop, lim);
    }
    return limite;
  }
  private obtLimitO(prop, lim, form?) {
    let auxLimits = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        auxLimits = p;
        if (auxLimits === undefined) {
          auxLimits = p;
        } else if (moment(auxLimits.periodo).isBefore(moment(p.periodo))) {
          auxLimits = p;
        }
      }
    }
    var met = '';
    var pers = 'AHO_13';
    if (this.encabezadoMetrica === 1) {
      met = 'totalSaldo';
    } else {
      met = 'totalCuentas';
    }

    if (!auxLimits || !auxLimits.limites['AHO_13']) {
      return 0;
    }

    let d = auxLimits.limites['AHO_13'].filter(d => d.codigoTipoCuenta === prop.id);
    if (d.length !== 0) {
      if (form === undefined) {
        return this.formatoNum(d[0][met].limits[lim], true);
      } else {
        return d[0][met]['limits'][lim];
      }
    } else {
      return 0;
    }
    return 0;
  }
  private obtLimitN(prop, lim, form?) {
    let auxLimits = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        auxLimits = p;
        if (auxLimits === undefined) {
          auxLimits = p;
        } else if (moment(auxLimits.periodo).isBefore(moment(p.periodo))) {
          auxLimits = p;
        }
      }
    }

    var pers = '';
    var met = '';

    if (this.encPerspectiva !== 'Saldo') {
      pers = 'AHO_12';
    } else {
      pers = 'AHO_11';
    }
    if (this.encabezadoMetrica === 1) {
      met = 'totalSaldo';
    } else {
      met = 'totalCuentas';
    }

    if (!auxLimits) {
      return 0;
    }

    if (auxLimits !== undefined && auxLimits.limites
      && auxLimits.limites[pers] && auxLimits.limites[pers][prop.id] && auxLimits.limites[pers][prop.id][met]) {
      if (form === undefined) {
        return this.formatoNum(auxLimits.limites[pers][prop.id][met].limits[lim], true);
      } else {
        return auxLimits.limites[pers][prop.id][met].limits[lim];
      }
    } else {
      return 0;
    }
    return 0;
  }
  //Evalua si el monto se encuentra en el rango determinado para asignar icono correspondiente
  public enRango(i) {
    const max = this.obtLimit(i, 'max', '');
    const min = this.obtLimit(i, 'min', '');
    if (min < max) {
      if ((i.porcentaje * 100) > max) {
        //el monto sobrepasa el maximo establecido
        return "cancel";
      } else if ((i.porcentaje * 100) >= min && (i.porcentaje * 100) <= max) {
        //el monto esta en rango 
        return "check_circle";
      } else if ((i.porcentaje * 100) < min) {
        //esta por debajo del rango
        return "cancel";
      }
    } else {
      //limites incongruentes
      return "help";
    }
    return "help";
  }
  //validar ingreso de datos numericos para los limites
  public validaNumeros(event) {
    if (event.which < 48 || event.which > 57) {
      event.preventDefault();
    }
  }
  //Agrega las comas a los datos ingresados
  public formateoLim(i, limite) {
    var valor = Number(document.getElementById(limite + '' + i)["value"].replace(/,/g, ""));
    var aux = this.formatoNum(valor, false);
    document.getElementById(limite + '' + i)["value"] = aux;
  }
  //funcion exportar tabla a excel
  public exportarExcel() {
    var titulos = [], encabezado = [], datos = [], totales = [];
    if(this.idPlantilla == 7){
      titulos.push("");
      titulos.push("");
      titulos.push(this.translate.instant('credito.concentracion.titulo1Tabla' + this.encabezadoMetrica));
      titulos.push("");
      titulos.push(this.translate.instant('credito.concentracion.titulo3Tabla'));
      titulos.push("");
      titulos.push("");

      for (var i = 1; i < 7; i++) {
        if (i == 3) {
          encabezado.push(this.translate.instant('credito.concentracion.encabezado' + i + this.encabezadoMetrica));
        } else if (i == 4) {
          encabezado.push("%");
          encabezado.push("%" + this.translate.instant('credito.concentracion.encabezado' + i));
        } else if (i == 5) {
          encabezado.push("%" + this.translate.instant('credito.concentracion.encabezado' + i));
        } else {
          encabezado.push(this.translate.instant('credito.concentracion.encabezado' + i));
        }
      }  
    }else{
      encabezado.push(this.translate.instant('credito.concentracion.encabezado1'));
      encabezado.push(this.translate.instant('credito.concentracion.encabezado31'));
      encabezado.push("%");
    }
    for (const i of this.datos) {
      var aux = [];
      aux.push(i.descripcion);
      if(this.idPlantilla === 7) aux.push(i.promedio);
      aux.push(i.monto);
      aux.push(i.porcentaje);
      if(this.idPlantilla === 7){
        aux.push(Number(i.min / 100));
        aux.push(i.max / 100);
        if (i.rango == "info") {
          aux.push("!");
        } else if (i.rango == "done") {
          aux.push("✓");
        } else if (i.rango == "close") {
          aux.push("×");
        } else {
          aux.push("");
        }
      }
      datos.push(aux);
    }
    if(this.idPlantilla == 7){
      totales.push("Total");
      if(this.idPlantilla === 7) totales.push(Number((this.totales.promedio).toFixed(0)));
      totales.push(this.totales.monto);
      totales.push(this.totales.porcentaje*100);
      totales.push("");
      totales.push("");
      totales.push("");  
    }else{
      datos.push(["Total",this.totales.monto,this.totales.porcentaje]);
    }       
    var t = this.idPlantilla === 7 ? 'credito' : 'liquidez';
    let tituloHoja = this.translate.instant(t+'.concentracion.tituloTabla' + this.encabezadoMetrica) + " | " + this.encPerspectiva + " | " + this.escrituraPeriodo(this.subTitles)
    let arch = this.translate.instant(t+'.concentracion.tituloTabla' + this.encabezadoMetrica) + " " + this.encPerspectiva + " " + this.escrituraPeriodo(this.subTitles)
    if(this.idPlantilla === 7) this.exportExcel.excelLiquidezConcentracion(tituloHoja, titulos, encabezado, datos, totales, arch);
    else this.exportExcel.generateExcel(tituloHoja, encabezado, datos, arch, [Aligment.LEFT, Aligment.RIGHT, Aligment.CENTER], [FormatText.TEXT, FormatText.NUMBER, FormatText.PORCENTAJE])
  }
  //exportar grafica en imagen 
  public exportarGrafica1() {
    const titulos = {
      titulo: this.translate.instant('credito.concentracion.tituloTabla11') + ' | ' + this.encPerspectiva,
      subtitulo: this.escrituraPeriodo(this.subTitles),
      nombreArch: 'Concentracion_' + this.encPerspectiva
    };

    if (this.graficador1) {
      this.graficador1.exportImg(1, titulos);
    }
  }

  public exportarGrafica2() {
    const titulos = {
      titulo: this.translate.instant('credito.concentracion.tituloTabla11') + ' | ' + this.encPerspectiva,
      subtitulo: this.subTitlesH,
      nombreArch: 'Concentracion_Historico_' + this.encPerspectiva
    };

    if (this.graficador2) {
      this.graficador2.exportImg(2, titulos);
    }
  }
  // Exportar gráfica desde el modal ampliado
  public exportarGraficaModal() {
    if (this.tituloModal === 'concen') {
      // Exportar gráfica 1 (zona 3 en el modal)
      const titulos = {
        titulo: this.translate.instant('credito.concentracion.tituloTabla11') + ' | ' + this.encPerspectiva,
        subtitulo: this.escrituraPeriodo(this.subTitles),
        nombreArch: 'Concentracion_' + this.encPerspectiva
      };

      if (this.graficador1) {
        this.graficador1.exportImg(3, titulos);
      }
    } else if (this.tituloModal === 'histo') {
      // Exportar gráfica 2 (zona 4 en el modal)
      const titulos = {
        titulo: this.translate.instant('credito.concentracion.tituloTabla11') + ' | ' + this.encPerspectiva,
        subtitulo: this.subTitlesH,
        nombreArch: 'Concentracion_Historico_' + this.encPerspectiva
      };

      if (this.graficador2) {
        this.graficador2.exportImg(4, titulos);
      }
    }
  }
}
